/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notifications_Simple_Subscribeddesc1Inputs */

const id_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda berlangganan ${i?.count} topik notifikasi`)
};

const ms_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda melanggan ${i?.count} topik pemberitahuan`)
};

const da_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du abonnerer på ${i?.count} notifikationsemner`)
};

const de_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sie haben ${i?.count} Benachrichtigungsthemen abonniert`)
};

const en_us2_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're subscribed to ${i?.count} notification topics`)
};

const es_es2_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás suscrito a ${i?.count} temas de notificación`)
};

const es_mx2_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás suscrito a ${i?.count} temas de notificación`)
};

const fil_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Naka-subscribe ka sa ${i?.count} notification topic`)
};

const fr_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous êtes abonné à ${i?.count} sujets de notification`)
};

const it_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei iscritto a ${i?.count} argomenti di notifica`)
};

const hu_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feliratkoztál ${i?.count} értesítési témára`)
};

const nl_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je bent geabonneerd op ${i?.count} meldingonderwerpen`)
};

const no_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du abonnerer på ${i?.count} varslingsemner`)
};

const pl_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jesteś subskrybowany do ${i?.count} tematów powiadomień`)
};

const pt_br2_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're subscribed to ${i?.count} notification topics`)
};

const pt_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Está subscrito a ${i?.count} tópicos de notificação`)
};

const ro_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ești abonat la ${i?.count} subiecte de notificare`)
};

const fi_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olet tilannut ${i?.count} ilmoitusaihetta`)
};

const sv_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du prenumererar på ${i?.count} notisämnen`)
};

const vi_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bạn đã đăng ký ${i?.count} chủ đề thông báo`)
};

const tr_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} bildirim konusuna abonesiniz`)
};

const cs_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máte předplaceno ${i?.count} témat oznámení`)
};

const bg_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Абонирани сте за ${i?.count} теми за известия`)
};

const ru_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы подписаны на ${i?.count} тем уведомлений`)
};

const uk_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ви підписані на ${i?.count} тем сповіщень`)
};

const ar_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أنت مشترك في ${i?.count} موضوع إشعار`)
};

const hi_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आप ${i?.count} सूचना विषयों की सदस्यता ले चुके हैं`)
};

const th_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณสมัครรับ ${i?.count} หัวข้อการแจ้งเตือน`)
};

const ja_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の通知トピックを購読中`)
};

const zh_cn2_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're subscribed to ${i?.count} notification topics`)
};

const zh_hant1_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're subscribed to ${i?.count} notification topics`)
};

const ko_notifications_simple_subscribeddesc1 = /** @type {(inputs: Notifications_Simple_Subscribeddesc1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`알림 주제 ${i?.count}개를 구독 중입니다`)
};

/**
* | output |
* | --- |
* | "You're subscribed to {count} notification topics" |
*
* @param {Notifications_Simple_Subscribeddesc1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_subscribeddesc1 = /** @type {((inputs: Notifications_Simple_Subscribeddesc1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Subscribeddesc1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_subscribeddesc1(inputs)
	if (locale === "ms") return ms_notifications_simple_subscribeddesc1(inputs)
	if (locale === "da") return da_notifications_simple_subscribeddesc1(inputs)
	if (locale === "de") return de_notifications_simple_subscribeddesc1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_subscribeddesc1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_subscribeddesc1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_subscribeddesc1(inputs)
	if (locale === "fil") return fil_notifications_simple_subscribeddesc1(inputs)
	if (locale === "fr") return fr_notifications_simple_subscribeddesc1(inputs)
	if (locale === "it") return it_notifications_simple_subscribeddesc1(inputs)
	if (locale === "hu") return hu_notifications_simple_subscribeddesc1(inputs)
	if (locale === "nl") return nl_notifications_simple_subscribeddesc1(inputs)
	if (locale === "no") return no_notifications_simple_subscribeddesc1(inputs)
	if (locale === "pl") return pl_notifications_simple_subscribeddesc1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_subscribeddesc1(inputs)
	if (locale === "pt") return pt_notifications_simple_subscribeddesc1(inputs)
	if (locale === "ro") return ro_notifications_simple_subscribeddesc1(inputs)
	if (locale === "fi") return fi_notifications_simple_subscribeddesc1(inputs)
	if (locale === "sv") return sv_notifications_simple_subscribeddesc1(inputs)
	if (locale === "vi") return vi_notifications_simple_subscribeddesc1(inputs)
	if (locale === "tr") return tr_notifications_simple_subscribeddesc1(inputs)
	if (locale === "cs") return cs_notifications_simple_subscribeddesc1(inputs)
	if (locale === "bg") return bg_notifications_simple_subscribeddesc1(inputs)
	if (locale === "ru") return ru_notifications_simple_subscribeddesc1(inputs)
	if (locale === "uk") return uk_notifications_simple_subscribeddesc1(inputs)
	if (locale === "ar") return ar_notifications_simple_subscribeddesc1(inputs)
	if (locale === "hi") return hi_notifications_simple_subscribeddesc1(inputs)
	if (locale === "th") return th_notifications_simple_subscribeddesc1(inputs)
	if (locale === "ja") return ja_notifications_simple_subscribeddesc1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_subscribeddesc1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_subscribeddesc1(inputs)
	return ko_notifications_simple_subscribeddesc1(inputs)
});
export { notifications_simple_subscribeddesc1 as "notifications.simple.subscribedDesc" }